import { SITE, IMAGES } from "../data/site";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { Stamp } from "../components/Stamp";
import { IconFlame } from "../components/Icons";

const VALUES = [
  {
    title: "Bun & Patty Homemade",
    desc: "Roti dan patty sapi dibuat sendiri, bukan beli jadi. Teksturnya beda, rasanya lebih nendang.",
  },
  {
    title: "Saus Luber",
    desc: "Mayo, BBQ, dan keju disiram nggak pelit sampai netes. Siapkan tisu — memang begitu cara makannya.",
  },
  {
    title: "Harga Lapak",
    desc: "Kualitas rasa yang serius, harga tetap ramah kantong. Prinsip itu dipegang sejak lapak pertama.",
  },
];

const TIMELINE = [
  {
    year: "2004",
    title: "Lapak pertama di Barito",
    desc: `Juli 2004, ${SITE.founder} membuka lapak burger 2×1 meter di kawasan Barito, Blok M, dengan modal Rp7 juta. Nama “Blenger” dipilih dari bahasa Jawa: kenyang berlebih sampai puas.`,
  },
  {
    year: "—",
    title: "“It's Worth The Wait”",
    desc: "Porsi besar, saus melimpah, harga lapak. Orang rela antri panjang — dan antrian itu sendiri akhirnya jadi ciri khas yang melekat sampai sekarang.",
  },
  {
    year: "Kini",
    title: "Jujukan burger jalanan Jaksel",
    desc: "Dua puluh tahun lebih kemudian, Burger Blenger tetap jadi tujuan di Jakarta Selatan dan sekitarnya — dari Blok M sampai Tangerang Selatan — dengan resep dan porsi yang sama.",
  },
];

export default function Tentang() {
  return (
    <>
      <section className="mx-auto max-w-6xl px-5 pb-16 pt-28 md:pt-36">
        <Breadcrumbs items={[{ label: "Tentang", href: "/tentang/" }]} />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Sejak Juli 2004</p>
        <h1 className="mt-3 max-w-3xl font-display text-4xl uppercase leading-[0.95] tracking-tight text-cream sm:text-5xl lg:text-6xl">
          Dari lapak Barito jadi legenda burger Jaksel.
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-sand sm:text-lg">
          {SITE.name} bukan burger waralaba. Ia lahir dari lapak mungil 2×1 meter
          di kawasan Barito, Blok M — dan bertahan dua puluh tahun lebih karena
          satu prinsip: porsi harus bikin blenger.
        </p>
      </section>

      {/* Photos */}
      <section className="mx-auto grid max-w-6xl gap-5 px-5 md:grid-cols-2" aria-label="Suasana lapak">
        <img
          src={IMAGES.streetNight.src}
          alt={IMAGES.streetNight.alt}
          width={IMAGES.streetNight.w}
          height={IMAGES.streetNight.h}
          loading="lazy"
          decoding="async"
          className="aspect-[10/7] w-full rotate-1 border-4 border-cream/10 object-cover"
        />
        <img
          src={IMAGES.stallBW.src}
          alt={IMAGES.stallBW.alt}
          width={IMAGES.stallBW.w}
          height={IMAGES.stallBW.h}
          loading="lazy"
          decoding="async"
          className="aspect-[10/7] w-full -rotate-1 border-4 border-cream/10 object-cover md:translate-y-8"
        />
      </section>

      {/* Timeline */}
      <section className="mx-auto max-w-6xl px-5 py-20 md:py-28" data-testid="timeline-section">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Perjalanan</p>
        <h2 className="mt-3 font-display text-2xl uppercase tracking-tight text-cream sm:text-3xl lg:text-4xl">
          Cerita di balik antrian.
        </h2>
        <div className="mt-12 space-y-0">
          {TIMELINE.map((t, i) => (
            <article key={t.title} className="grid gap-4 border-t border-white/10 py-10 md:grid-cols-12" data-testid={`timeline-item-${i}`}>
              <div className="md:col-span-3">
                <span className="font-display text-4xl uppercase tracking-wide text-blood">{t.year}</span>
              </div>
              <div className="md:col-span-9">
                <h3 className="font-display text-xl uppercase tracking-wide text-cream sm:text-2xl">{t.title}</h3>
                <p className="mt-3 max-w-2xl leading-relaxed text-sand">{t.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Values */}
      <section className="border-t border-white/10 bg-coal2" data-testid="values-section">
        <div className="mx-auto max-w-6xl px-5 py-20 md:py-24">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Prinsip Lapak</p>
          <h2 className="mt-3 font-display text-2xl uppercase tracking-tight text-cream sm:text-3xl lg:text-4xl">
            Yang nggak pernah berubah.
          </h2>
          <ul className="mt-10 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
            {VALUES.map((v) => (
              <li key={v.title} className="bg-coal2 p-8" data-testid={`value-${v.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <IconFlame className="h-6 w-6 text-ember" />
                <h3 className="mt-5 font-display text-xl uppercase tracking-wide text-cream">{v.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-sand">{v.desc}</p>
              </li>
            ))}
          </ul>
          <div className="mt-12 text-center">
            <Stamp className="-rotate-2 text-cheddar">{SITE.slogan}</Stamp>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-5 py-20 text-center md:py-24">
        <h2 className="font-display text-2xl uppercase tracking-tight text-cream sm:text-3xl lg:text-4xl">
          Ceritanya enak, burgernya lebih enak.
        </h2>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <a href="/menu/" data-testid="tentang-menu-button" className="btn-primary px-7 py-3.5 text-sm">
            Lihat Menu
          </a>
          <a href="/lokasi/" data-testid="tentang-location-button" className="btn-ghost px-7 py-3.5 text-sm">
            Kunjungi Outlet
          </a>
        </div>
      </section>
    </>
  );
}
